import io from 'socket.io-client';

export const socket = io('wss://mdldigital.mandalahotel.com.vn/' || '', 
{
  path: '/noti-ws/socket.io',
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  autoConnect: true,
  transports: ['websocket'],
  withCredentials: true,
  upgrade: false,
  forceNew: true,
}
);
